<template>
  <transition name="showHeader">
    <div class="header-animat global-header">
      <a-layout-header
        :class="['ant-header-fixedHeader', 'ant-header-common']"
        style="height: 40px; padding: 0; line-height: 40px;">
        <div class="main-header" style=" height: 40px; padding-left: 12px;">
          <div class="common-logo">
            <logo />
            <div v-show="!collapsed" class="common-layout-header-title">
              微海翘财
            </div>
          </div>
          <div class="common-application" :style=" { 'paddingLeft': collapsed ? '0' : '58px' } ">
            <a-popover v-model="showSysList" trigger="click" placement="bottomLeft">
              <a v-if="defaultSystemList.length" style="color: #fff;" @click="doStaff">
                <menu-icon type="hi-wodeyingyong" fontSize="14px" />
                我的应用
              </a>
              <template slot="content">
                <div class="common-box">
                  <div
                    v-for="(item, index) in defaultSystemList"
                    v-show="!accountProxy || item.code === 'REIM'"
                    :key="index"
                    class="common-box-item"
                    @click="jumpSys(item)"
                    @mouseover="doOver(index)"
                    @mouseleave="doLeave"
                  >
                    <img :src="item.logoUrl" class="item-img" />
                    <span class="item-title">{{ item.name }}</span>
                    <span v-show="across === index && item.defaultAccess === 0" class="item-change" @click.stop="systemSt(item)">选择默认</span>
                    <span v-show="across === index && item.defaultAccess === 1" class="item-change" @click.stop="systemSt(item)">取消默认</span>
                    <div v-show="item.defaultAccess === 1" class="item-change-active">默认</div>
                  </div>
                </div>
              </template>
            </a-popover>
          </div>
          <div class="header-tabs-sum">
            <span class="col-line before-tab"></span>
          </div>
          <div style="flex: 1; overflow: auto;">
            <tabs />
          </div>
          <weihai-app-download />
          <div v-if="!accountProxy" class="header-tabs-sum tabs-sum-list">
            <tab-close/>
          </div>
          <div class="user-menu-dropdown ml16">
            <user-menu/>
          </div>
        </div>
      </a-layout-header>
      <import-uopload-tips />
      <statement-tips />
    </div>
  </transition>
</template>

<script>
import UserMenu from '../tools/UserMenu'
import { directive as clickOutside } from 'v-click-outside-x'
import Logo from '../tools/Logo'
import Tabs from './Tabs.vue'
import tabClose from './tabClose.vue'
import MenuIcon from '@/components/common-icon/MenuIcon'
import { mapGetters } from 'vuex'
import { setDefaultSystem, removeDefaultSystem } from '@/api/login'
import { startMicroApp } from '@/utils/microTools'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import importUoploadTips from '../MyImportDowload/Tips.vue'
import WeihaiAppDownload from './WeihaiAppDownload.vue'
import statementTips from '../Statement/Tips.vue'

export default {
  name: 'GlobalHeader',
  components: {
    UserMenu,
    Logo,
    MenuIcon,
    Tabs,
    tabClose,
    importUoploadTips,
    WeihaiAppDownload,
    statementTips
  },
  directives: { clickOutside },
  computed: {
    ...mapGetters(['systemList', 'collapsed', 'firstLogin', 'accountProxy']),
    defaultSystemList () {
      let list = this.systemList ? [...this.systemList] : []
      list = list.sort((a, b) => b.defaultAccess - a.defaultAccess)
      return list
    }
  },
  mounted () {
    if (this.firstLogin) {
      this.showSysList = true
      this.$store.commit('SET_FIRST_LOGIN', false)
    }
  },
  props: {
    mode: {
      type: String,
      default: 'sidemenu'
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    },
    openNew: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showSysList: false, // 是否选择应用
      across: -1 // 鼠标划过应用对应的下标
    }
  },
  methods: {
    // 鼠标移入
    doOver (index) {
      this.across = index
    },
    // 鼠标移出
    doLeave () {
      this.across = -1
    },
    // 应用展开与关闭
    doStaff () {
      if (!this.defaultSystemList?.length) {
        this.$message.warn('没有授权应用', 1)
      } else {
        this.showSysList = !this.showSysList
      }
    },
    toggle () {
      this.$emit('toggle')
    },
    systemSt (item) {
      if (item.defaultAccess) {
        removeDefaultSystem().then(res => {
          if (res.code === '0') {
            this.$message.success('设置成功')
            this.$store.dispatch('GetSystemList')
          }
        }).catch(err => {
          this.$notification.error({
            message: '错误',
            description: err.msg || '请求失败，请重试',
            duration: 3
          })
        })
      } else {
        const req = {
          subsystemId: item.id
        }
        setDefaultSystem(req).then(res => {
          if (res.code === '0') {
            this.$message.success('设置成功')
            this.$store.dispatch('GetSystemList')
          }
        }).catch(err => {
          this.$notification.error({
            message: '错误',
            description: err.msg || '请求失败，请重试',
            duration: 3
          })
        })
      }
    },
    openBlankTab({ internetSubSystemUrl }) {
      const token = this.$cookie.get(ACCESS_TOKEN)
      if (internetSubSystemUrl && token) {
        window.open(`${internetSubSystemUrl}&tokenId=${token}`, '_blank')
      }
    },
    jumpSys (item) {
      this.doCancel()
      if (item.internetSubSystem) {
        this.openBlankTab(item)
      } else {
        startMicroApp(item)
      }
    },
    // 点击取消
    doCancel () {
      this.showSysList = false
    },
    onClickoutside () {
      this.doCancel()
    }
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
.header-animat {
  position: relative;
  z-index: @ant-global-header-zindex;
}
.showHeader-enter-active {
  transition: all .25s ease;
}
.showHeader-leave-active {
  transition: all .5s ease;
}
.showHeader-enter, .showHeader-leave-to {
  display: none;
}
// .fade-enter-active {
//   transition: all 2s ease !important;
// }
// .fade-leave-active {
//   transition: all 2s ease !important;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   display: none !important;
// }
.common-layout-header-title {
  float: left;
  margin-left: 6px;
  color: #fff;
  font-weight: 400;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 40px;
}
.common-logo {
  display: flex;
  align-items: center;
  float: left;
  padding-right: 12px;
  color: #fff;
}
.header-tabs {
  flex: 1;
}
.header-tabs-sum {
  display: flex;
  align-items: center;
}
.col-line {
  width: 1px;
  height: 12px;
  margin: 0 12px;
  background: #f5f5f5;
  opacity: .3;
  &.before-tab {
    margin-right: 0;
  }
}
.common-application {
  position: relative;
  display: flex;
  align-items: center;
  // border: 1px solid red;
  .common-icon {
    width: 1px;
    height: 16px;
    margin-right: 12px;
    background: #fff;
    opacity: .3;
  }
  .common-font {
    color: #fff;
    font-size: 12px;
    cursor: pointer;
  }
}
.common-box {
  // border: 1px solid red;
  // position: absolute;
  // top: 40px;
  // left: 12px;
  margin: -12px -16px;
  display: flex;
  // border: 1px solid #EEEEEE;
  flex-wrap: wrap;
  width: 498px;
  padding-bottom: 16px;
  // background: #fff;
  // border-radius: 3px;
  // padding-top: 16px;
  // box-shadow: 0 6px 24px 0 rgba(61, 64, 69, .12);
  // background: red;
  .common-box-item {
    // border: 1px solid blue;
    position: relative;
    display: flex;
    align-items: center;
    width: 225px;
    height: 56px;
    margin-top: 16px;
    margin-left: 16px;
    background: #fafafa;
    border: 1px solid #fafafa;
    border-radius: 3px;
    cursor: pointer;
    // justify-content: space-around;
    .item-img {
      width: 32px;
      height: 32px;
      margin-left: 16px;
      border-radius: 3px;
    }
    .item-title {
      width: 97px;
      margin-left: 16px;
      color: #333;
      font-size: 14px;
      font-family: 'PingFangSC-Regular';
    }
    .item-change {
      color: #00a497;
      font-size: 12px;
      font-family: 'PingFangSC-Regular';
      letter-spacing: 0;
      opacity: .85;
    }
    .item-change-active {
      position: absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 15px;
      padding-right: 5px;
      color: #fff;
      font-size: 12px;
      font-family: 'PingFangSC-Regular';
      line-height: 15px;
      letter-spacing: 0;
      text-align: right;
      background: url('./img/default.png') no-repeat;
      background-size: 100%;
    }
  }
  .common-box-item:hover {
    background: #e5f5f4;
    border: 1px solid #00a497;
  }
}
</style>
